module.exports = __webpack_public_path__ + "img/special_3.06daf208.png";